import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'

/**
 * Gets the data for ManagePaidAmounts screen.
 * @param {number} campaignId
 */
export default async campaignId => {
  const query = `query 
  ($campaignId:ID!) {
      campaign(id:$campaignId){
        cityPlans {
          nodes {
            id
            city {
              id
              name
            }
          }
        }
      }
    }`

  const response = await callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
  return response.json()
}



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/BonusResults/gql.js